import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";

import { login, LoginRequest } from "@/api";
import { UserStatus } from "@/types";
import { CookiesService } from "@/utils";
import { useUIStore } from "stores/ui.store";

const useLoginWithCreds = () => {
  const openToast = useUIStore((state) => state.actions.toast.openToast);
  const { replace } = useRouter();

  return useMutation({
    mutationFn: (body: LoginRequest) => {
      return login(body);
    },
    onSuccess: ({ tokens, user }) => {
      if (user.status === UserStatus.INACTIVE || user.status === UserStatus.PENDING) {
        return openToast({ variant: "error", message: "Your account is inactive or has not verified yet." });
      }

      CookiesService.setAccessToken(tokens.accessToken);
      CookiesService.setRefreshToken(tokens.refreshToken);

      switch (user.status) {
        case UserStatus.ACTIVE:
          replace("/platform");
          break;

        case UserStatus.NOT_FINISHED_PROFILE:
          CookiesService.setUserStatus(user.status);
          replace("/platform/profile/edit/gallery/all");
          break;

        case UserStatus.NOT_ONBOARDED:
          CookiesService.setUserStatus(user.status);
          replace("/auth/onboarding");
          break;
      }
    },
    onError: (error) => {
      const customError = error as any;

      openToast({ message: customError.response.data.message, variant: "error" });
    },
  });
};

export { useLoginWithCreds };
